import "../_namespaces.js";
import "backbone-relational";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Models ??= {};

AssessmentViewer.Models.Base = class Base extends Backbone.RelationalModel {
  // Syntactic sugar
  static initializeRelations() {
    this.setup();
  }
};
